import { Theme } from '@mui/material'

const useStyles = {
  container: {
    position: 'relative',
    display: 'block',
  },
  leftBorder: (color: string) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '5px',
    height: '100%',
    backgroundColor: color,
    borderRadius: '12px 0 0 12px',
  }),
  card: (backgroundColor: string) => ({
    paddingY: 1.5,
    paddingX: 2,
    gap: 2,
    backgroundColor,
    borderRadius: 1.5,
  }),
  timeContainer: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    paddingX: 1,
  },
  periodText: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  divider: (theme: Theme) => ({
    width: '1px',
    backgroundColor: theme.palette.divider,
  }),
  cardRightContainer: { gap: 2, flex: 1 },
  detailsContainer: {
    flexDirection: 'column',
    gap: 1,
    flex: 1,
  },
  locationText: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  alertName: {
    fontWeight: 500,
  },
  needsResponseIcon: (theme: Theme) => ({ fontSize: 16, color: theme.palette.error.main }),
  respondedIcon: (theme: Theme) => ({ fontSize: 16, color: theme.palette.info.main }),
}

export default useStyles
